import React from "react"
import {IonButton, IonIcon, useIonAlert} from "@ionic/react"
import {trashOutline, trashSharp} from "ionicons/icons"
import {useHistory}     from "react-router"
import {useTranslation} from "react-i18next"

import {TimeLimit}    from "@customTypes/TimeLimit"
import {useTimeLimits as useItems} from "../../../contexts/TimeLimitContext"

interface componentProps {
    item: TimeLimit;
}

const ButtonDelete: React.FC<componentProps> = ({item}) => {
    const { deleteItem } = useItems()
    const history        = useHistory()
    const [presentAlert] = useIonAlert()
    const { t }          = useTranslation()

    const alertDelete = async () => {
        if (
            (item.keyTimeLimits && item.keyTimeLimits?.length > 0)
            || (item.lockTimeLimits && item.lockTimeLimits?.length > 0)
        ) {
            return presentAlert({
                header:  t('time-limits.alerts.delete.header_not_possible'),
                message: t('time-limits.alerts.delete.message_not_possible'),
                buttons: [{
                    text:    t('common.cancel'),
                    role:    'cancel'
                }],
            })
        }

        return presentAlert({
            header:  t('time-limits.alerts.delete.header'),
            message: t('time-limits.alerts.delete.message'),
            buttons: [{
                text:    t('common.cancel'),
                role:    'cancel'
            }, {
                text:    t('common.delete'),
                role:    'confirm',
                handler: () => onDelete(),
            },],
        })

    }

    const onDelete = async () => {
        await deleteItem(item)

        history.push('/time-limits')
    }

    return (
        <IonButton type="button" color="danger" fill="outline" className="ion-padding-start"
                   onClick={() => alertDelete()}>
            <IonIcon slot="start" ios={trashOutline} md={trashSharp} />
            {t('common.delete')}
        </IonButton>
    )
}

export default ButtonDelete
